import { cilArrowLeft } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CImage,
  CLink,
  CNav,
  CNavItem,
  CNavLink,
  CRow,
  CTabContent,
  CTabPane,
} from '@coreui/react'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getSingleAppUser } from 'src/redux/appusers'
import imgPic from 'src/assets/images/profile.png'

const Showusers = () => {
  const dispatch = useDispatch()
  const { id } = useParams()
  const [activeKey, setActiveKey] = useState(1)
  const { singleAppUser } = useSelector((state) => state.appuser)

  useEffect(() => {
    dispatch(getSingleAppUser(id))
  }, [dispatch, id])

  const goBack = () => {
    window.history.back()
  }

  return (
    <CContainer>
      <div className="d-flex justify-content-end">
        <CButton color="secondary" size="sm" className="text-white" onClick={() => goBack()}>
          <CIcon icon={cilArrowLeft} className="text-white" /> Go Back
        </CButton>
      </div>
      <CRow className="justify-content-center my-2">
        <CCol md={12} lg={12} xl={12}>
          <CCard className="px-4">
            <CCardBody className="p-4">
              <CNav variant="pills" layout="fill" role="tablist">
                <CNavItem role="presentation" className="">
                  <CNavLink
                    active={activeKey === 1}
                    component="button"
                    role="tab"
                    aria-controls="1-tab-pane"
                    aria-selected={activeKey === 1}
                    onClick={() => setActiveKey(1)}
                  >
                    Personal Details
                  </CNavLink>
                </CNavItem>
                <CNavItem role="presentation">
                  <CNavLink
                    active={activeKey === 2}
                    component="button"
                    role="tab"
                    aria-controls="2-tab-pane"
                    aria-selected={activeKey === 2}
                    onClick={() => setActiveKey(2)}
                  >
                    Residence Details
                  </CNavLink>
                </CNavItem>
              </CNav>
              <CTabContent className="my-4">
                <CTabPane role="tabpanel" aria-labelledby="1-tab-pane" visible={activeKey === 1}>
                  <CRow>
                    <CCol sm={3} lg={3} md={3}>
                      <div className="image-size m-2" style={{ height: 250 }}>
                        <CLink href={singleAppUser?.profile_pic} target="blank">
                          <CImage
                            src={singleAppUser?.profile_pic ? singleAppUser?.profile_pic : imgPic}
                            className="image-profile"
                            style={{ height: 250, width: 250 }}
                          />
                        </CLink>
                      </div>
                    </CCol>

                    <CCol sm={3} lg={3} md={3}>
                      <h6 className="py-1">
                        Name:
                        <text className="text-medium-emphasis px-2">{singleAppUser?.name}</text>
                      </h6>
                      <h6 className="py-1">
                        Username:
                        <text className="text-medium-emphasis px-2">{singleAppUser?.username}</text>
                      </h6>
                      <h6 className="py-1">
                        Mobile:
                        <text className="text-medium-emphasis px-2">
                          {singleAppUser?.mobile_no}
                        </text>
                      </h6>
                      <h6 className="py-1">
                        WhatsApp:
                        <text className="text-medium-emphasis px-2">
                          {singleAppUser?.whatsapp_no}
                        </text>
                      </h6>
                      <h6 className="py-1">
                        Email:
                        <text className="text-medium-emphasis px-2">{singleAppUser?.email_id}</text>
                      </h6>
                    </CCol>
                    <CCol sm={3} lg={3} md={3}>
                      <h6 className="py-1">
                        City:
                        <text className="text-medium-emphasis px-2">{singleAppUser?.city}</text>
                      </h6>

                      <h6 className="py-1">
                        State:
                        <text className="text-medium-emphasis px-2">{singleAppUser?.state}</text>
                      </h6>
                      <h6 className="py-1">
                        Country:
                        <text className="text-medium-emphasis px-2">{singleAppUser?.country}</text>
                      </h6>
                      <h6 className="py-1">
                        Registration:
                        <text className="text-medium-emphasis px-2">
                          {singleAppUser?.registration}
                        </text>
                      </h6>
                      <h6 className="py-1">
                        Address:
                        <text className="text-medium-emphasis px-2">{singleAppUser?.address}</text>
                      </h6>
                    </CCol>
                  </CRow>
                </CTabPane>
                <CTabPane role="tabpanel" aria-labelledby="2-tab-pane" visible={activeKey === 2}>
                  <CRow>
                    <CCol sm={6} lg={6} md={6}>
                      <h6 className="py-1">
                        Residence Type:
                        <text className="text-medium-emphasis px-2">
                          {singleAppUser?.residence1_type}
                        </text>
                      </h6>
                      <h6 className="py-1">
                        Residence Area:
                        <text className="text-medium-emphasis px-2">
                          {singleAppUser?.residence1_area}
                        </text>
                      </h6>
                    </CCol>

                    <CCol sm={6} lg={6} md={6}>
                      <h6 className="py-1">
                        Residence Type:
                        <text className="text-medium-emphasis px-2">
                          {singleAppUser?.residence2_type}
                        </text>
                      </h6>
                      <h6 className="py-1">
                        Residence Area:
                        <text className="text-medium-emphasis px-2">
                          {singleAppUser?.residence2_area}
                        </text>
                      </h6>
                    </CCol>
                  </CRow>
                </CTabPane>
              </CTabContent>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  )
}

export default Showusers
